const ProductFilterToggle = {
  methods: {
    handleClick: function() {
      bus.$emit('product_filter_toggle')
    }
  },
}

export default ProductFilterToggle
